/* eslint-disable string-to-lingui/missing-lingui-transformation */

import {Helmet} from 'react-helmet'
import {useLocation} from 'react-router'

import {Button, Loading, Stack, Text} from '@pleo-io/telescope'

import {absurd} from '@product-web/utils'
import {useIntegrationsGatewayAuth} from '@product-web-features/integrations-gateway-auth'
import {Page} from '@product-web-features/ui-page'

// NB: the code in this file is a POC and should be removed when the igateway integration installation flow is implemented

export const ConnectScreen = () => {
    return (
        <>
            <Helmet>
                <title>Connect accounting integration</title>
            </Helmet>
            <Page showNav layout="narrow">
                <Page.Header>
                    <Page.Title align="center">IGateway + Pandium Connection </Page.Title>
                </Page.Header>

                <Stack align="center">
                    <ConnectScreen.Content />
                </Stack>
            </Page>
        </>
    )
}

const Content: React.FC = () => {
    // Location state was the quickest way to get the integration identifier to this screen
    // This should be replaced with a more robust solution, likely using React.Context
    const location = useLocation()
    const {state} = location

    const iGatewayAuth = useIntegrationsGatewayAuth(state?.system)

    switch (iGatewayAuth.connectionStatus) {
        case 'LOADING_URLS':
            return <Loading />
        case 'ERROR':
            return <ConnectScreen.LoadingError />
        case 'IDLE':
            return (
                <ConnectScreen.ConnectButton
                    handleConnect={iGatewayAuth.startConnection}
                    connectionStatus={iGatewayAuth.connectionStatus}
                />
            )
        case 'STARTED':
            return <ConnectScreen.ConnectButton connectionStatus={iGatewayAuth.connectionStatus} />
        case 'CONNECTED':
            return <ConnectScreen.ConnectionSuccess />
        default:
            return absurd(iGatewayAuth)
    }
}
ConnectScreen.Content = Content

const NoIdentifier = () => <Text>No integration identifier ❌</Text>
ConnectScreen.NoIdentifier = NoIdentifier

const LoadingError = () => <Text>Error loading URLs 🚫</Text>
ConnectScreen.LoadingError = LoadingError

const ConnectButton = ({
    handleConnect,
    connectionStatus,
}: {
    handleConnect?: () => void
    connectionStatus?: ReturnType<typeof useIntegrationsGatewayAuth>['connectionStatus']
}) => (
    <Button onClick={handleConnect} variant="primary" loading={connectionStatus === 'STARTED'}>
        Connect your accounting system
    </Button>
)
ConnectScreen.ConnectButton = ConnectButton

const ConnectionSuccess = () => <Text variant="2xlarge-accent">Connected successfully ✅</Text>
ConnectScreen.ConnectionSuccess = ConnectionSuccess
